import * as React from "react";

export interface AnchorProps {
    id?: string;
}

const Anchor = ({ id }: AnchorProps) => {
    return <div className="anchor" id={id} />;
};

export default Anchor;
